export enum CorrectedDocumentTypes {
    NoticeOfCancelledCommentPeriod = "Notice of Cancelled Comment Period/Hearing",
    NoticeOfContinuedCommentPeriod = "Notice of Continued Comment Period/Hearing",
    NoticeOfLegislativeDisapproval = "Notice of Legislative Disapproval of Rules",
    NoticeOfRulemakingIntent = "Notice of Rulemaking Intent",
    NoticeOfWithdrawnRules = "Notice of Withdrawn Rules",
    PermanentRuleDocumentEnactingClause = "Permanent rule document (enacting clause)",
    PermanentRuleDocumentPreamble = "Permanent rule document (preamble)",
    StatementOfSubmissionToGovAndLeg = "Statement of Submission to Governor and Legislature"
}